// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2hGcf","productName":"Table_productName__3fL2y"};